import Button from "@/components/Button";
import { PropsWithChildren } from "react";
import {
  SubmitHandler,
  UseFormHandleSubmit,
  UseFormRegister,
} from "react-hook-form";

interface Props<T> {
  onSubmit: SubmitHandler<T>;
  onClear: () => void;
  handleSubmit: UseFormHandleSubmit<T>;
  register: UseFormRegister<T | { keyword: string }>;
  modalElements: JSX.Element;
  hiddenModal: boolean;
}

const ModalSearchChildContainer = <T,>(
  props: PropsWithChildren<Props<T>>,
): JSX.Element => {
  const {
    handleSubmit,
    register,
    modalElements,
    hiddenModal,
    onSubmit,
    onClear,
    children,
  } = props;

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="space-y-20">
          <div className="space-y-12 px-12">
            <input
              id="keyword"
              name="keyword"
              placeholder={"キーワードをご入力ください"}
              type="text"
              className="w-full text-base"
              autoComplete="off"
              {...register("keyword")}
            />
            {children}
          </div>

          <div className="sticky flex flex-col space-y-8 bottom-0 left-0 right-0 w-full p-8 bg-white bg-opacity-50">
            <Button type="submit">検索</Button>
            <Button type="button" color="outlined" onClick={onClear}>
              検索のクリア
            </Button>
          </div>
        </div>
      </form>

      {!hiddenModal && (
        <div className="fixed inset-0 w-full h-full">{modalElements}</div>
      )}
    </div>
  );
};
export default ModalSearchChildContainer;
